import React from "react";
import PropTypes from "prop-types";
import TrashButton from "../TrashButton";
import Button from "../Button";
import { formattedPhone } from "components/shared/formattedPhone";
import styles from "./ContactCard.module.css";
import { useTranslation } from "react-i18next";

export function ContactCard({ onEdit, onDelete, contact }) {
  const {t} = useTranslation();
  return (
    <div className={styles.contactCard}>
      <div className={styles.contactInfo}>
        <span className={styles.name}>
          {contact.firstName} {contact.lastName}
        </span>
        <span className={styles.phoneNum}>{formattedPhone(contact.phone)}</span>
      </div>
      <div className={styles.buttons}>
        <Button
          onClick={onEdit}
          buttonText={t("Edit")}
          className={styles.editButton}
        />
        <TrashButton onClick={onDelete} />
      </div>
    </div>
  );
}

ContactCard.propTypes = {
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
